<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>退费学生列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <!--<Col span="5" offset="1">
            <Form-item label="注册时间：">
              <Date-picker  v-model="regDateRange" format="yyyy-MM-dd" type="daterange"
                          placement="bottom-start" placeholder="选择日期"
                          @on-change="regDateChange" style="width: 220px;"></Date-picker>
            </Form-item>
          </Col>-->
          <Col :span="6">
            <Form-item label="退费时间：">
              <Date-picker  v-model="applyDateRange" format="yyyy-MM-dd" type="daterange"
                            placement="bottom-start" placeholder="选择日期"
                            @on-change="applyDateChange" style="width: 100%;"></Date-picker>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程顾问：">
              <admin-user-select :status="1" adminGroupCode="adviser" v-model="queryParam.adviserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学员ID：">
              <Input name="uid" v-model="queryParam.uid" placeholder="不支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生姓名：">
              <Input name="stuName" v-model="queryParam.stuName" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生手机号：">
              <Input name="mobile" v-model="queryParam.mobile" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学导：">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.adminUserId"></admin-user-select>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <div >
      <Row>
        <Col :span="1">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索</Button>
        </Col>
        <Col :span="1">
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="ios-download"
                        @click="exportData">导出
                </Button>
        </Col>
        <Col :span="1">
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="nuclear"
                        @click="showInsertRefundModal">申请退费
                </Button>
        </Col>
      </Row>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/financial/user/refund/list"
          :params="queryParam" :onLoading="onLoading"></List>

    <ToRefundModal v-model="showRefundModal" :successCallback="search"></ToRefundModal>
  </div>
</template>

<script>
    import dates from '@/tools/date/dates.js'
    import ToRefundModal from './modal/ToRefundModal.vue'
export default {
      name: 'UserRefundList',
      components: {
        ToRefundModal
      },
      data () {
        let $moment = this.$moment
        return {
          showRefundModal: false,
          searchLoading: false,
          exportLoading: false,
          reload: 0,
          queryParam: {
            regStartTime: null,
            regEndTime: null,
            applyStartTime: null,
            applyEndTime: null,
            uid: '',
            adviser: '',
            stuName: '',
            mobile: '',
            studyAdviser: '',
            adviserId: '',
            adminUserId: '',
          },
          regDateRange: [],
          applyDateRange: [],
          title: [
            {
              title: 'ID/姓名',
              align: 'center',
              // width: 150,
              render: (h, params) => {
                let row = params.row
                return h('span', row.uid + '-' + row.nickName)
              }
            },
            {
              title: '手机号',
              // width: 130,
              align: 'center',
              key: 'mobile',
              render: (h, params) => {
                return h('Poptip', {
                  props: {
                    trigger: 'hover'
                  }
                }, [
                  h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) +
                '****' + params.row.mobile.substring(7) : params.row.mobile),
                  // 当前行展示的数据
                  h('div', {slot: 'content'}, params.row.mobile)
                ])
              }
            },
            {
              title: '学导',
              // width: 130,
              align: 'center',
              key: 'studyAdviser'
            },
            {
              title: '课程顾问',
              // width: 130,
              align: 'center',
              key: 'adviser'
            },
            {
              title: '注册渠道',
              // width: 120,
              align: 'center',
              key: 'regType',
              // render: (h, params) => {
              //   let regType = params.row.regType
              //   let canalEnum = $constant.getEnum($constant.studentCanal, regType)
              //   return h('div', canalEnum && canalEnum.text)
              // }
            },
            {
              title: '注册时间',
              align: 'center',
              // width: 170,
              key: 'regTime',
              render: (h, params) => {
                let regTime = params.row.regTime
                if (regTime === 0) {
                  return
                }
                return h('span', regTime && $moment(regTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
              }
            },
            {
              title: '退费时间',
              align: 'center',
              // width: 170,
              key: 'refundTime',
            },
            {
              title: '退费原因',
              align: 'center',
              // width: 170,
              key: 'remark',
            },
          ]
        }
      },
      mounted: function () {
        this.init()
      },
      created: function () {
        this.init()
      },
      methods: {
        init () {
          let query = this.$route.query
          if (query) {
            if (query.regStartTime) {
              this.regDateRange[0] = dates.format(parseInt(query.regStartTime) * 1000, 'YYYY-MM-DD') + ''
            }
            if (query.regEndTime) {
              this.regDateRange[1] = dates.format(parseInt(query.regEndTime) * 1000, 'YYYY-MM-DD') + ''
            }
            if (query.applyStartTime) {
              this.applyDateRange[0] = dates.format(parseInt(query.applyStartTime) * 1000, 'YYYY-MM-DD') + ''
            }
            if (query.applyEndTime) {
              this.applyDateRange[1] = dates.format(parseInt(query.applyEndTime) * 1000, 'YYYY-MM-DD') + ''
            }
            if (query.uid) {
              this.queryParam.uid = query.uid
            }
            if (query.adviser) {
              this.queryParam.adviser = query.adviser
            }
            if (query.studyAdviser) {
              this.queryParam.studyAdviser = query.studyAdviser
            }
            if (query.stuName) {
              this.queryParam.stuName = query.stuName
            }
            if (query.mobile) {
              this.queryParam.mobile = query.mobile
            }
          }
        },
        exportData (type) {
          this.exportLoading = true
          this.$http.get('/financial/user/refund/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
            if (response.data) {
              let blob = new Blob([response.data], {type: 'text/csv'})
              let link = document.createElement('a')
              link.target = '_blank'
              link.href = window.URL.createObjectURL(blob)
              link.download = '退费学生.csv'
              link.click()
              this.exportLoading = false
            } else {
              this.$Message.error(response.msg)
            }
          }).catch((e) => {
            this.exportLoading = false
          })
        },
        search () {
          this.reload = new Date().getTime()
        },
        onLoading (loading) {
          this.searchLoading = loading
        },
        showInsertRefundModal () {
          this.showRefundModal = true
        },
        applyDateChange (dateRange) {
          if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
            let startTime = new Date(new Date(dateRange[0]).toLocaleDateString()).getTime()
            let endTime = new Date(new Date(dateRange[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
            this.queryParam.applyStartTime = parseInt(startTime / 1000)
            this.queryParam.applyEndTime = parseInt(endTime / 1000)
          } else {
            this.queryParam.applyStartTime = null
            this.queryParam.applyEndTime = null
            this.applyDateRange = []
          }
          this.search()
        },
      }
    }
</script>

<style scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// UserRefundList.vue?17d238ce